exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.tns-inner {\n  height: 100%;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
